import { Private_Routes } from '@common/url';
import { SearchSmIcon } from '@prophecy/icons';
import { theme } from '@prophecy/theme';
import { Input } from '@prophecy/ui-v3';
import { StyledInputContainer } from '@prophecy/ui-v3/Input/styled';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const StyledInput = styled(Input)`
  ${StyledInputContainer} {
    border: 0;
    box-shadow: ${theme.shadows.lg};
  }

  width: 100%;
`;

const StyledForm = styled.form`
  width: 100%;
`;

export function LineageSearchInput({ value = '', onFocus }: { value?: string; onFocus?: () => void }) {
  const [searchStr, setSearchStr] = useState(value);
  const navigate = useNavigate();

  const handleSearch = (e: React.SyntheticEvent) => {
    e.preventDefault();
    if (!searchStr) return;
    navigate(Private_Routes.Lineage_Search.getUrl(undefined, { search: searchStr }));
  };

  return (
    <StyledForm onSubmit={handleSearch}>
      <StyledInput
        icon={<SearchSmIcon type='default' onClick={handleSearch} />}
        iconPlacement='left'
        placeholder='Search Lineage....'
        inputSize='l'
        value={searchStr}
        onChange={setSearchStr}
        onFocus={onFocus}
        data-test-id='lineage-search-input-field'
      />
    </StyledForm>
  );
}
